import React, {useContext} from "react";
import {useSortable} from "@dnd-kit/sortable";
import {CSS} from "@dnd-kit/utilities";
import {GridRow, GridRowProps} from "@mui/x-data-grid";
import {Colors} from "@bounce/shared/ui";
import {DndEnabledContext, RowHandleContext} from "./SortableRowContext";

export const getSortableRowStyle = (
  baseStyle: React.CSSProperties | undefined,
  {transform, transition, isDragging}: Pick<ReturnType<typeof useSortable>, "transform" | "transition" | "isDragging">
): React.CSSProperties => ({
  ...baseStyle,
  transform: CSS.Transform.toString(transform),
  transition,
  opacity: isDragging ? 0.5 : 1,
  backgroundColor: isDragging ? Colors.tertiary._100 : undefined,
  position: "relative",
  zIndex: isDragging ? 1 : 0,
});

export const SortableGridRow = (props: GridRowProps) => {
  const enabled = useContext(DndEnabledContext);
  const {attributes, listeners, setNodeRef, transform, transition, isDragging} = useSortable({
    id: props.rowId,
    disabled: !enabled,
  });

  return (
    <RowHandleContext.Provider value={{attributes, listeners}}>
      <GridRow
        ref={setNodeRef}
        {...props}
        style={getSortableRowStyle(props.style, {transform, transition, isDragging})}
      />
    </RowHandleContext.Provider>
  );
};
